"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIF_EXT = exports.MP4_EXT = exports.JPEG_EXT = exports.JPG_EXT = exports.MXF_EXT = exports.GIF_EXT = exports.HEIC_EXT = exports.MediaMimeWhitelist = exports.MimeRootType = void 0;
exports.MimeRootType = {
    image: 'image',
    video: 'video',
    audio: 'audio',
};
exports.MediaMimeWhitelist = new Set([
    exports.MimeRootType.image,
    exports.MimeRootType.video,
]);
exports.HEIC_EXT = 'heic';
exports.GIF_EXT = 'gif';
exports.MXF_EXT = 'mxf';
exports.JPG_EXT = 'jpg';
exports.JPEG_EXT = 'jpeg';
exports.MP4_EXT = 'mp4';
exports.TIF_EXT = 'tif';
//# sourceMappingURL=mime.js.map